import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/vsts/work/1/s/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Hero = makeShortcode("Hero");
const Resources = makeShortcode("Resources");
const Media = makeShortcode("Media");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="heading, text" background="rgb(0, 132, 97)" mdxType="Hero" />
    <h1 {...{
      "id": "panoptica"
    }}>{`Panoptica`}</h1>
    <p>{`An EnsureworX solution.`}</p>
    <Resources slots="heading, links" mdxType="Resources" />
    <h4 {...{
      "id": "resources"
    }}>{`Resources`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ensureworx.com/"
        }}>{`Contact EnsureworX`}</a></li>
    </ul>
    <h2 {...{
      "id": "what-is-panoptica"
    }}>{`What is Panoptica?`}</h2>
    <p>{`Panoptica is a SaaS-based model review solution that supports multi-user multi-location model reviews using a variety of access options including HoloLens, iPad Pro, VR and Web.`}</p>
    <p>{`It supports the complete model review process from setting up the model review meeting to inviting participants, sectioning and importing models, the model review process itself and a robust reporting capability. Panoptica provides an environment for participants to make dramatic improvements in model review outcomes, including construction rework cost and time reductions, and the security, safety, ergonomics, and operational efficiencies of your resulting facility.`}</p>
    <Media slots="video" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=VlZZ7ocJNyY&ab_channel=EnsureworX/"
      }}>{`https://www.youtube.com/watch?v=VlZZ7ocJNyY&ab_channel=EnsureworX/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      